import billing from "../api-provider";

export const getCareOpportunityList = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getCareOpportunityList`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getCareOpportunitySummary = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getCareOpportunitySummary`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getCareOpportunityNotes = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getCareOpportunityNotes`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const updateCareOpportunity = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/updateCareOpportunity`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const getPracticeUsers = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/getPracticeUsers`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const assignCareOpportunity = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/assignCareOpportunity`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const addCareOpportunityNote = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/addCareOpportunityNote`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp.data;
  } catch {
    console.error("Unable to get count");
  }
};

export const processCareOpptFile = async (payload, token) => {
  try {
    const resp = await billing({
      url: `/provider/processCareOpptFile`,
      method: "POST",
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return resp;
  } catch (error) {
    console.log("error processCareOpptFile: ", error);
  }
};
